/**
 *  @class
 *  @function ProductCompareTable
 */
if (!customElements.get('product-compare-table')) {
  class ProductCompareTable extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.container = this.querySelector('.compare-lightbox--data');
      this.addEventListeners();
    }

    addEventListeners() {
      this.renderTableBound = this.renderTable.bind(this);
      this.addEventListener('render-product-compare-modal', this.renderTableBound);
    }

    disconnectedCallback() {
      if (this.renderTableBound) {
        this.removeEventListener('render-product-compare-modal', this.renderTableBound);
      }
    }

    renderTable() {
      this.classList.add('loading');
      this.fetchProducts();
    }

    getSelectedProducts() {
      return JSON.parse(localStorage.getItem('compare-products-vision')) || [];
    }

    async fetchProducts() {
      const compareProducts = this.getSelectedProducts();
      const returnArray = [];

      try {
        await Promise.all(compareProducts.map(async (product) => {
          const response = await fetch(`${product.url}?view=compare`);
          const text = await response.text();
          returnArray[product.id] = this.getSectionInnerHTML(text, '.compare-lightbox--data');
        }));
      } finally {
        this.classList.remove('loading');
      }

      let returnHtml = '';
      compareProducts.forEach((product) => {
        returnHtml += returnArray[product.id];
      });

      this.container.style.setProperty('--columns', compareProducts.length);
      this.container.innerHTML = returnHtml;

      this.equalHeights();
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    equalHeights() {
      const firstTable = this.container.querySelector('.compare-lightbox--table');
      if (!firstTable) return;

      const rowCount = firstTable.querySelectorAll('.compare-lightbox--row').length;
      for (let i = 0; i < rowCount; i++) {
        this.equalizeTableRowHeightAcrossTables(i);
      }
    }

    equalizeTableRowHeightAcrossTables(rowPosition) {
      const tables = this.container.querySelectorAll('.compare-lightbox--table');
      let maxHeight = 0;

      tables.forEach(table => {
        const rows = table.querySelectorAll('.compare-lightbox--row');
        if (rows.length > rowPosition) {
          maxHeight = Math.max(maxHeight, rows[rowPosition].clientHeight);
        }
      });

      tables.forEach(table => {
        const rows = table.querySelectorAll('.compare-lightbox--row');
        if (rows.length > rowPosition) {
          rows[rowPosition].style.height = `${maxHeight}px`;
        }
      });
    }
  }
  customElements.define('product-compare-table', ProductCompareTable);
}
